import { Action, createReducer, on } from '@ngrx/store';

import * as TogglesActions from './toggles.actions';

import { FeatureFlagToggleList } from '../../interface/feature-flags.interface';

export const TOGGLES_FEATURE_KEY = 'toggles';

export const initialTogglesState: FeatureFlagToggleList = {};

const reducer = createReducer(
  initialTogglesState,
  on(TogglesActions.updated, (_, toggles) => ({
    ...toggles,
    type: undefined,
  }))
);

export function togglesReducer(state: FeatureFlagToggleList | undefined, action: Action) {
  return reducer(state, action);
}
